import { render, staticRenderFns } from "./stores-list.vue?vue&type=template&id=8c78d70a&"
import script from "./stores-list.vue?vue&type=script&lang=js&"
export * from "./stores-list.vue?vue&type=script&lang=js&"
import style0 from "./stores-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c78d70a')) {
      api.createRecord('8c78d70a', component.options)
    } else {
      api.reload('8c78d70a', component.options)
    }
    module.hot.accept("./stores-list.vue?vue&type=template&id=8c78d70a&", function () {
      api.rerender('8c78d70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/stores/stores-list.vue"
export default component.exports